import { useCallback, useContext } from "react";
import flatten from "lodash.flatten";

import { ApiRequest } from "api/makeApiRequest/ApiRequest";
import { combineAPIRequests } from "api/utils/combineAPIRequests";
import { SearchResults } from "types-and-validators/SearchResults";
import { useAccountStatus } from "hooks/useAccountStatus";
import { AuthContext } from "components/AuthProvider/AuthProvider";

export function useFetchPurchases<T>(
	apiRequests: (
		isMentor: boolean | undefined,
		uid: string
	) => ApiRequest<SearchResults<T>>[],
	requestType: string
) {
	const { isMentor } = useAccountStatus();
	const [{ uid }] = useContext(AuthContext);

	const fetchPurchases = useCallback(() => {
		if (!uid) {
			throw new Error("No UID");
		}

		const reqs = apiRequests(isMentor, uid);

		const req = combineAPIRequests(reqs);

		return {
			...req,
			ready: req.ready.then(allresults =>
				flatten(
					allresults.map(result => {
						if (!result) {
							return [];
						}
						return result.page;
					})
				)
			),
			type: requestType
		};
	}, [uid, isMentor, apiRequests, requestType]);

	return fetchPurchases;
}
